import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { PureBiData, ClickDownloadButtonBiEvent } from '@wix/da-bi/pkg/events';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { ReferralType } from '@wix/da-bi/pkg/constants';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

export const LoginToDownloadButton: React.FC<
  React.PropsWithChildren<Props>
> = ({
  deviation: { deviationId, isDownloadable, isPurchasable },
  className,
}) => {
  const { t } = useTranslation();
  const { isLoggedIn, restrictToLoggedIn } = useRestrictToLoggedIn();

  if (!isDownloadable && !isPurchasable) {
    return null;
  }

  return isLoggedIn ? null : (
    <ActionBarItemWrapper popoverWrapperClassName={className}>
      <ActionBarB18Link
        onClick={restrictToLoggedIn(ReferralType.ANON_DOWNLOAD)}
        biData={PureBiData<ClickDownloadButtonBiEvent>({
          evid: 350,
          ispaiddownload: isPurchasable ? 1 : 0,
          deviationid: deviationId,
          sectionname: 'action_bar',
        })}
      >
        {t('actionbar.download.mustLogIn')}
      </ActionBarB18Link>
    </ActionBarItemWrapper>
  );
};
LoginToDownloadButton.displayName = 'LoginToDownloadButton';

export default LoginToDownloadButton;
